import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../redux/reducers/rootReducer";
import { useStyles } from "../../../../../shared/styles/useStyles";
import { useState } from "react";
import { IContractingOffice } from "../../../../../redux/types/types";
import { startSetContractingOffice } from "../../../../../redux/actions/correspondenceActions";

function useEnableOCRForm() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { contractingOffice } = useSelector(
    (state: AppState) => state.correspondence
  );
  const [checked, setChecked] = useState(
    contractingOffice?.enableOCRF ?? false
  );

  const [isLoading, setIsLoading] = useState(false);

  const toggleChecked = () => {
    setChecked((prev) => !prev);
  };

  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    const contractingOfficeData: IContractingOffice = {
      ...contractingOffice,
      enableOCRF: checked,
    } as IContractingOffice;

    await dispatch(
      startSetContractingOffice(
        contractingOfficeData,
        "ocrSuccessfully",
        "ocrError"
      )
    );
    setIsLoading(false);
  };

  return {
    classes,
    checked,
    toggleChecked,
    isLoading,
    submit,
  };
}

export default useEnableOCRForm;
